import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UserServiceModal } from 'src/app/modals/userservice.modal';
import { getSubdomain } from 'tldts';
import { ForgotDialogComponent } from '../forgot-dialog/forgot-dialog.component';
import { AccountService } from '../services/account.service';
import { AutoshipConfigurationService } from '../services/autoshipConfiguration.service';
import { Cart1Service } from '../services/cart1.service';
import { ConfigService } from '../services/config.service';
import { NotificationService } from '../services/notification.service';
import { OrderService } from '../services/order.service';
import { ProductService } from '../services/product.service';
import { RestApiService } from '../services/restapi.service';
import { UserService } from '../services/user.service';
import { UtilityService } from '../services/utility.service';
import { PaymentService } from '../services/payment.service';
import { StoreConstantsService } from '../services/store-constants.service';


@Component({
  selector: 'app-login-dialog-component',
  templateUrl: './login-dialog-component.component.html',
  styleUrls: ['./login-dialog-component.component.scss']
})
export class LoginDialogComponentComponent implements OnInit {
  _forMobileScreen:any=false
  showPassword: boolean = false;

  public userInfo = {
    username: '',
    password: '',
    guestemail: ''
  };
  userService: UserServiceModal;
  public guestUser = {};
  public issignin = true;
  public isguest = true;
  public showLoginSection: boolean = false;
  previousType: any;

  constructor(
    public dialogRef: MatDialogRef<LoginDialogComponentComponent>,
    private titleService: Title,
    private router: Router,
    private accountService: AccountService,
    public user: UserService,
    public orderService: OrderService,
    public cartsService: Cart1Service,
    public notificationService: NotificationService,
    public translate: TranslateService,
    public itemsService: ProductService,
    public apiService: RestApiService,
    private cookieService: CookieService,
    public utilityService: UtilityService,
    public autoshipConfigurationService: AutoshipConfigurationService,
    public configService: ConfigService,
    public dialog: MatDialog,
    public paymentService: PaymentService,
    private storeConstantsService: StoreConstantsService
  ) {

    this.userService = user.userServiceModal;
    this.cookieService.deleteAll('/');
  }

  ngOnInit() {
    this._forMobileScreen = window.innerWidth <= 700;

    this.translate.get('global_Company_Title').subscribe((text: string) => {
      this.titleService.setTitle(this.translate.instant('pagetitle_login') + ' | ' + text);
    });
    window.scrollTo(0, 0);
    this.previousType = this.userService.customerTypeID;
    this.load();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onClear(): void {
    this.dialogRef.close();
  }

  private load() {
    localStorage.setItem('PostLoginEvents', null);

    if (this.userService.customerData && !this.userService.customerData.FirstName) {
    }
  }

  checkitem() {
    return (this.itemsService.selectedOrderItems.length > 0 || this.itemsService.selectedAutoOrderItems.length > 0);
  }

  manageflow(guest, signin) {
    this.isguest = guest;
    if (signin) {
      this.clearStorage();
      const url = 'Home';
      window.open(url, '_self');
    } else {
      this.issignin = signin;
    }
  }

  private clearStorage() {
    this.orderService.calculateOrderResponse = {};
    this.cartsService.clearCart();
    this.user.clearData();
    this.user.setDefault();
    localStorage.removeItem('guestLogin');
  }

  loginFunction(username?: string, password?: string) {
    localStorage.setItem('guestLogin', 'false');
    this.user.clearCustomerData();
    localStorage.removeItem('guestLogin');
    const loginrequest = {
      granttype: 'password',
      scope: 'office',
      username: username || this.userInfo.username,
      password: password || this.userInfo.password
    };
    this.apiService.Login(loginrequest).subscribe(
      (result) => {
        if (result && result.status == 200 && result.body.Status != 1) {
          try {
            // Get customer reward points first
            this.apiService.GetCustomerRewardPoints(result.body.CustomerId)
            .subscribe((rewardResult: any) => {
              const { Data } = rewardResult;
              if(typeof Data == "number") {
                this.userService.customerData['rewardPointBalance'] = Data;
              }
            });
            
            // Get customer data - only set isLoggedIn after this succeeds
            this.accountService.getCustomerData(result.body.CustomerId).then((data: any) => {
              if (data && data.Data) {
                // Only set isLoggedIn after user data is successfully loaded
                localStorage.setItem('isLoggedIn', 'true');
                localStorage.setItem('user', JSON.stringify(data.Data));
                this.userService.customerData = data.Data;
                localStorage.setItem('userService', JSON.stringify(this.userService));
                
                // Load payment methods for the user
                this.paymentService.getPaymentType().then(() => {
                  // Payment methods loaded successfully
                }).catch((error) => {
                  console.error('Failed to load payment methods:', error);
                });
                this.userService.customerTypeID = this.userService.customerData.CustomerType;
                if (this.previousType !== this.userService.customerTypeID) {
                  this.userService.couponInfo.Allcoupons = [];
                  this.autoshipConfigurationService.autoshipDate = '';
                  this.userService.shippingMethods = [];
                  this.userService.selectedShippingMethod = "";
                  this.autoshipConfigurationService.init();
                }
                if (!this.utilityService.isEmptyObject(this.userService.customerData.DefaultShippingAddress)) {
                  this.user.setShippingAddress();
                } else {
                  this.userService.shippingAddress = new UserServiceModal().newshippingAddress;
                }

                if (this.userService.customerData.WebAlias) {
                  this.apiService.validateWebAlias(this.userService.customerData.WebAlias).subscribe((res: any) => {
                    if (res.Data) {
                      this.userService.WebAlias = this.userService.customerData.WebAlias;
                      this.loginredirect(this.userService.WebAlias);
                    }else{
                      // Use customer's WebAlias even if validation fails, clear cart and redirect to marketplace
                      this.clearCartForMemberLogin();
                      const webAlias = this.userService.customerData.WebAlias || 'www';
                      this.userService.WebAlias = webAlias;
                      location.href = `${location.origin}/${webAlias}/marketplace`;
                      this.dialogRef.close(true)
                    }
                  }, (error) => {
                    if (error.Data && !error.Data.WebAlias) {
                      this.notificationService.error('error_', 'webalias_not_exists');
                      return false;
                    }
                    // If validation fails due to network error or other issues, clear cart and redirect to marketplace
                    this.clearCartForMemberLogin();
                    const webAlias = this.userService.customerData.WebAlias || 'www';
                    this.userService.WebAlias = webAlias;
                    location.href = `${location.origin}/${webAlias}/marketplace`;
                    this.dialogRef.close(true);
                  },
                    () => {

                    });
                }
                else if (this.userService.customerData.SponsorId) {
                  this.apiService.getSearchCustomerDetail(this.userService.customerData.SponsorId).subscribe((resp: any) => {
                    if (resp.Data) {
                      this.apiService.validateWebAlias(resp.Data.WebAlias).subscribe((res: any) => {
                        if (res.Data) {
                          this.userService.WebAlias = resp.Data.WebAlias;
                          const webAlias = resp.Data.WebAlias || 'www';
                          location.href = `${location.origin}/${webAlias}`;
                        }
                      }, (error) => {
                        if (error.Data && !error.Data) {
                          this.notificationService.error('error_', 'webalias_not_exists');
                          return false;
                        }
                      },
                        () => {

                        });
                    }
                  }, (error) => {
                    if (error.Data && !error.Data.WebAlias) {
                      this.notificationService.error('error_', 'webalias_not_exists');
                      return false;
                    }
                  },
                    () => {

                    });
                }
                else {
                  // Customer doesn't have WebAlias, clear cart and redirect to marketplace for logged-in users
                  this.clearCartForMemberLogin();
                  const webAlias = 'www';
                  this.userService.WebAlias = webAlias;
                  location.href = `${location.origin}/${webAlias}/marketplace`;
                  this.dialogRef.close(true);
                }
              } else {
                // Clear login state if customer data is invalid
                localStorage.removeItem('isLoggedIn');
                localStorage.removeItem('user');
                localStorage.removeItem('userService');
                this.user.clearCustomerData();
                this.notificationService.error('error_', 'error_occured_try_again');
              }
            }).catch((error) => {
              // Clear login state if customer data loading fails
              localStorage.removeItem('isLoggedIn');
              localStorage.removeItem('user');
              localStorage.removeItem('userService');
              this.user.clearCustomerData();
              this.notificationService.error('error_', 'error_occured_try_again');
              console.error('ex', error);
            });
          } catch (successEx) {
            // Clear login state if any error occurs
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('user');
            localStorage.removeItem('userService');
            this.user.clearCustomerData();
            this.notificationService.error('error_', 'error_occured_try_again');
            console.error('ex', successEx);
          }
        } else {
          this.notificationService.error('error_', 'Authentication Failed');
        }
      }, err => {
        // Clear login state if login API call fails
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('user');
        localStorage.removeItem('userService');
        this.user.clearCustomerData();
        this.notificationService.error('error_', 'error_occured_try_again');
      },
      () => {

      });
  }



  // *********** new method from neumi ****************
  private loginredirect(alias) {
    let newUrl: any;
    const subdomain = getSubdomain(window.location.host);
    newUrl = `${location.origin}/${alias}`;

    if (this.checkitem()) {
      this.userService.checkItems = true;
      window.location.assign(newUrl.replace('login', 'checkout'));
    } else {
      // Clear cart for member login and redirect to marketplace
      this.clearCartForMemberLogin();
      window.location.assign(newUrl.replace('login', 'marketplace'));
    }
  }

  navLoginPath(state) {
    this.router.navigate([state], { queryParams: { WebAlias: this.userService.WebAlias } });
  }


  redirectToForgotPassword() {
    this.onNoClick();
    const dialogRef = this.dialog.open(ForgotDialogComponent, {
      width: '800px',
      height: 'auto',
      data: LoginDialogComponentComponent,
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
    });



  }
  isMobile(): boolean {
    return false;
  }

  createGuestCustomer(guestemail) {
    this.userService.customerTypeID = 1;
    const randomPassword = '6Zy$Ce6yrzz';
    const request = {
      CustomerType: 1,
      EmailAddress: guestemail,
      FirstName: 'Guest User',
      LastName: 'Guest User',
      PrimaryAddress: {
        ShipTo: 'Guest User',
        Street1: 'No Address',
        Region: this.userService.regionMainState || 'UT',
        CountryCode: this.configService.commonData.selectedCountry || 'us'
      },
      SponsorId: this.userService.enrollerInfo.CustomerId || 2,
      Username: guestemail,
      Password: randomPassword
    };
    this.accountService.createGuestUser(request).subscribe((result) => {
      try {
        if (Number(result.Data) > 0) {
          this.loginFunction(this.userInfo.guestemail, randomPassword);
          this.userService.newUser = true;

          this.notificationService.success('Success', 'customer_created_successfully');
        } else {
          this.notificationService.error('error_', result.ErrorDescription);
        }
      } catch (ex) {
        this.notificationService.error('error_', 'error_occured_try_again');
      }
    },
      err => {
        // Do stuff whith your error
      },
      () => {

      });
  }

  showLogin(value: boolean) {
    this.showLoginSection = value;
  }
  @HostListener('window:resize', ['$event'])
  onWindowResize(event: Event) {
    this.windowResize(event);
  }
  windowResize(event: Event): void {
    this._forMobileScreen = window.innerWidth <= 700;
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  clearCartForMemberLogin() {
    // Clear all cart data from localStorage
    localStorage.removeItem('cart.order');
    localStorage.removeItem('cart.autoship');
    localStorage.removeItem('cart.packs');
    localStorage.removeItem('cartItem'); // Regular cart service
    
    // Clear sessionStorage cart data
    sessionStorage.removeItem('cart');
    
    // Clear cart items from services
    this.itemsService.selectedOrderItems = [];
    this.itemsService.selectedAutoOrderItems = [];
    this.itemsService.selectedPacks = [];
    
    // Set marketplace store ID for member pricing
    sessionStorage.setItem('selectedStoreId', this.storeConstantsService.getCurrentStoreConstants().MEMBERSTORE);
  }
}
